var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaceShip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4501 24.1819C25.6427 24.9997 25.7446 25.8525 25.7446 26.7292C25.7446 32.8441 20.7874 37.8013 14.6724 37.8013V28.9442M25.4501 24.1819C32.3406 19.1468 36.8167 11.0044 36.8167 1.81689C27.6295 1.81728 19.4878 6.29347 14.4532 13.1838M25.4501 24.1819C22.2972 26.4858 18.6388 28.1391 14.6724 28.9442M14.4532 13.1838C13.6349 12.991 12.7816 12.889 11.9044 12.889C5.78943 12.889 0.832275 17.8462 0.832275 23.9611H9.69131M14.4532 13.1838C12.1496 16.3366 10.4964 19.9949 9.69131 23.9611M14.6724 28.9442C14.4816 28.9829 14.2901 29.0197 14.0978 29.0545C12.4242 27.7275 10.9077 26.211 9.58072 24.5374C9.61559 24.3446 9.65246 24.1525 9.69131 23.9611M5.5599 28.3729C3.53043 29.8869 2.21629 32.3066 2.21629 35.0333C2.21629 35.4704 2.25006 35.8996 2.31514 36.3184C2.73399 36.3835 3.16321 36.4173 3.60031 36.4173C6.32696 36.4173 8.74668 35.1031 10.2606 33.0737M27.1286 14.273C27.1286 15.8018 25.8893 17.0411 24.3605 17.0411C22.8318 17.0411 21.5925 15.8018 21.5925 14.273C21.5925 12.7443 22.8318 11.505 24.3605 11.505C25.8893 11.505 27.1286 12.7443 27.1286 14.273Z",
    stroke: "#CCA159",
    strokeWidth: 1.66082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceShip);
export default __webpack_public_path__ + "static/media/space-ship.dd932fb0bb86da81f6b99d81202ffb08.svg";
export { ForwardRef as ReactComponent };